import classes from "./InstitutionPage.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import React, {useEffect, useState} from "react";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {useSession} from "../../hooks/useSession";
import Skeleton from "react-loading-skeleton";

export default function AdminPatternPage({setPageIdentifier}) {
    const {getSession, setSession} = useSession();

    const {MGMTSettings={}} = getSession();

    const {saveMGMTSettings} = AuthenticationApiCalls();

    const [settings, setSettings] = useState(() => {
        return JSON.parse(JSON.stringify(MGMTSettings));
    });
    const [rawSettings, setRawSettings] = useState(() => {
        return JSON.parse(JSON.stringify(MGMTSettings));
    });

    const [loading, setLoading] = useState(false);


    const isSaveBtnDisabled = () => {
        if (JSON.stringify(rawSettings) === JSON.stringify(settings)) {
            return true;
        }

        if (!settings.rootAdminRoles && !settings.rootAdminEmails) {
            return true;
        }

        return false;
    }

    useEffect(() => {
        setPageIdentifier("Admin Patterns");
    }, []);


    const handleSave = async () => {
        const obj = JSON.parse(JSON.stringify(settings));
        obj.rootAdminRoles = "";
        setLoading(true);
        saveMGMTSettings(obj).then(res => {
            if (res) {
                setRawSettings(obj);
                let session = getSession();
                session.MGMTSettings = obj;
                setSession(session);
            }

        }).finally(() => {
            setLoading(false);
        });
    }


    if (!!loading) {
        return (
            <div className={classes.parentContainer} style={{paddingTop: 50}}>
                <div className={classes.header}>
                    <Skeleton borderRadius={4} height={36} inline={true} width={150}/>
                </div>

                <div className={classes.card} style={{rowGap: 10, gridTemplateColumns: "none"}}>
                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={50} inline={true} width={"100%"}/>
                    <div style={{height: 20}}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={"60%"}/>
                </div>
            </div>
        );
    }


    return (
        <div className={classes.parentContainer} style={{paddingTop: 50}}>
            <div className={classes.header}>
                <YuJaButton style={{height: 36}} disabled={isSaveBtnDisabled()} onClick={handleSave}>
                    {"Save Changes"}
                </YuJaButton>
            </div>

            <div className={classes.card} style={{display: "flex", flexDirection: "column", alignItems: "start", minHeight: 180}}>
                {/*Admin Roles*/}
                {/*<div className={classes.column} style={{gap: 2}}>*/}
                {/*    <div className={classes.label}>Admin Roles</div>*/}
                {/*    <div className={classes.description}>Specific roles based on Onelogin that grant admin access. Separate with a comma.</div>*/}
                {/*</div>*/}
                {/*<YuJaTextBox*/}
                {/*    containerStyle={{height: 40, fontSize: 15}}*/}
                {/*    placeholder={"L1 Client Success Manager, L2 Client Success Manager"}*/}
                {/*    value={settings.rootAdminRoles || ""}*/}
                {/*    onChange={(event) => {*/}
                {/*        let copy = JSON.parse(JSON.stringify(settings));*/}
                {/*        copy.rootAdminRoles = event.target.value;*/}
                {/*        setSettings(copy);*/}
                {/*    }}*/}

                {/*/>*/}

                {/*<div/>*/}

                {/*Admin Emails*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>Admin Emails</div>
                    <div className={classes.description}>Specific email addresses that grant admin access. Separate with a comma.</div>
                </div>
                <YuJaTextBox
                    containerStyle={{height: 40, fontSize: 15}}
                    placeholder={"example@yuja.com, admin@yuja.com"}
                    value={settings.rootAdminEmails || ""}
                    onChange={(event) => {
                        let copy = JSON.parse(JSON.stringify(settings));
                        copy.rootAdminEmails = event.target.value;
                        setSettings(copy);
                    }}
                />
            </div>

        </div>
    );
}